import React from 'react';
import './productComponent.css'

const ProductComponent = ({ productLogo, productName, productTitle, productDescription, productUrl }) => {
    return (
        <div className='product-component'>
            <img className='product-logo' src={productLogo} alt="Logo with title" />
            <p className='product-name'>{productName}</p>
            {productUrl ? (
                <a className='product-title' href={productUrl} target="_blank" rel="noopener noreferrer">{productTitle}</a>
            ) : (
                <div className='product-title-line'>
                    <span className='product-title product-title-disabled'>{productTitle}</span>
                    <span className='product-coming-soon' aria-label="This product is coming soon">Coming Soon</span>
                </div>
            )}
            <p className='product-description'>{productDescription}</p>
        </div>
    )
}

export default ProductComponent
